export const apiExtension = {
    methods: {
        httpApiGet: async function(path, withProgress = true){
            try {

                let data = null;
                let api = $App.url.api + path;


                // Show progress bar
                if(withProgress) {
                    $App.event.$emit("app_running", true)
                }
                

                try {
                    let token = $App.getToken();

                    // ** ATTENTION need to add bearer token...
                    let response = await fetch(api, {
                        method: 'GET',
                        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                        headers: {
                            'Authorization': 'Bearer ' + token
                        },
                        redirect: 'follow', // manual, *follow, error
                        referrerPolicy: 'no-referrer', // no-referrer, *client
                    });

                    if (await response.ok) {
                        if (await response.status !== 204) {
                            data = await response.json();
                        }
                    } else {
                        let msg = await response.text();
                        $App.event.$emit("app_error", msg);
                    };

                } catch (error) {
                    $App.event.$emit("app_error", error);
                }

                // Hide progress bar
                if(withProgress) {
                    $App.event.$emit("app_running", false)
                }

                return data;

            } catch (error) {
                if ($App && $App.event) { $App.event.$emit("app_error", error); }
                else { console.log(error); }
                return null;
            }
        },
        httpApiTenantGet: async function(tenant, path, withProgress = true){
            try {

                let data = null;
                let api = $App.url.api + path;


                // Show progress bar
                if(withProgress) {
                    $App.event.$emit("app_running", true)
                }
                

                try {
                    let token = await $App.getAnonymousToken(tenant);

                    // ** ATTENTION need to add bearer token...
                    let response = await fetch(api, {
                        method: 'GET',
                        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                        headers: {
                            'Authorization': 'Bearer ' + token
                        },
                        redirect: 'follow', // manual, *follow, error
                        referrerPolicy: 'no-referrer', // no-referrer, *client
                    });

                    if (await response.ok) {
                        if (await response.status !== 204) {
                            data = await response.json();
                        }
                    } else {
                        let msg = await response.text();
                        $App.event.$emit("app_error", msg);
                    };

                } catch (error) {
                    $App.event.$emit("app_error", error);
                }

                // Hide progress bar
                if(withProgress) {
                    $App.event.$emit("app_running", false)
                }

                return data;

            } catch (error) {
                if ($App && $App.event) { $App.event.$emit("app_error", error); }
                else { console.log(error); }
                return null;
            }
        },
        httpApiPut: async function(path, param){
            try {

                let data = null;
                let api = $App.url.api + path;

                // Show progress bar
                $App.event.$emit("app_running", true)

                try {
                    let token = $App.getToken();

                    // ** ATTENTION need to add bearer token...
                    let response = await fetch(api, {
                        method: 'PUT',
                        mode: 'cors', // no-cors, *cors, same-origin
                        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                        credentials: 'same-origin', // include, *same-origin, omit
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + token
                        },
                        redirect: 'follow', // manual, *follow, error
                        referrerPolicy: 'no-referrer', // no-referrer, *client
                        body: JSON.stringify(param)
                    });

                    if (await response.ok) {
                        if (await response.status !== 204) {
                            
                            data = await response.json();
                        }
                    } else {
                        let msg = await response.text();
                        $App.event.$emit("app_error", msg);
                    };

                } catch (error) {
                    $App.event.$emit("app_error", error);
                }

                // Hide progress bar
                $App.event.$emit("app_running", false);

                return data;

            } catch (error) {
                if ($App && $App.event) { $App.event.$emit("app_error", error); }
                else { console.log(error); }
                return null;
            }
        },
        httpApiPost: async function(path, param){
            try {

                let data = null;
                let api = $App.url.api + path;

                // Show progress bar
                $App.event.$emit("app_running", true)

                try {
                    let token = $App.getToken();

                    // ** ATTENTION need to add bearer token...
                    let response = await fetch(api, {
                        method: 'POST',
                        mode: 'cors', // no-cors, *cors, same-origin
                        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                        credentials: 'same-origin', // include, *same-origin, omit
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + token
                        },
                        redirect: 'follow', // manual, *follow, error
                        referrerPolicy: 'no-referrer', // no-referrer, *client
                        body: JSON.stringify(param)
                    });

                    if (await response.ok) {
                        if (await response.status !== 204) {
                            
                            data = await response.json();
                        }
                    } else {
                        let msg = await response.text();
                        $App.event.$emit("app_error", msg);
                    };

                } catch (error) {
                    $App.event.$emit("app_error", error);
                }

                // Hide progress bar
                $App.event.$emit("app_running", false);

                return data;

            } catch (error) {
                if ($App && $App.event) { $App.event.$emit("app_error", error); }
                else { console.log(error); }
                return null;
            }
        },
        httpApiDelete: async function(path){
            try {

                let deleted = false;
                let api = $App.url.api + path;

                // Show progress bar
                $App.event.$emit("app_running", true)

                try {
                    let token = $App.getToken();

                    // ** ATTENTION need to add bearer token...
                    let response = await fetch(api, {
                        method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
                        mode: 'cors', // no-cors, *cors, same-origin
                        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                        credentials: 'same-origin', // include, *same-origin, omit
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + token
                        },
                        redirect: 'follow', // manual, *follow, error
                        referrerPolicy: 'no-referrer', // no-referrer, *client
                    });
    
                    if (await response.ok) {
                        deleted = true;
                    } else {
                        let msg = await response.text();
                        $App.event.$emit("app_error", msg);
                    };

                } catch (error) {
                    $App.event.$emit("app_error", error);
                }

                // Hide progress bar
                $App.event.$emit("app_running", false)
                return deleted;

            } catch (error) {
                if ($App && $App.event) { $App.event.$emit("app_error", error); }
                else { console.log(error); }
                return null;
            }
        },        
        httpGet: async function(path){
            try {

                let data = null;
                let api = $App.url.api + path;


                // Show progress bar
                $App.event.$emit("app_running", true)

                try {
                    let token = $App.getToken();

                    // ** ATTENTION need to add bearer token...
                    let response = await fetch(api, {
                        method: 'GET',
                        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                        headers: {
                            'Authorization': 'Bearer ' + token
                        },
                        redirect: 'follow', // manual, *follow, error
                        referrerPolicy: 'no-referrer', // no-referrer, *client
                    });

                    if (await response.ok) {
                        if (await response.status !== 204) {
                            data = await response.text();
                        }
                    } else {
                        let msg = await response.text();
                        $App.event.$emit("app_error", msg);
                    };

                } catch (error) {
                    $App.event.$emit("app_error", error);
                }

                // Hide progress bar
                $App.event.$emit("app_running", false)
                return data;

            } catch (error) {
                if ($App && $App.event) { $App.event.$emit("app_error", error); }
                else { console.log(error); }
                return null;
            }
        },
    }
}